import { FC } from 'react';

import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';
import { DirectoryProvider } from 'modules/directory/common/providers/DirectoryProvider';

import { useProductionCalendar } from '../hooks';
import { ProductionCalendarProvider } from '../providers';
import { ProductionCalendarView } from '../views/ProductionCalendarView';

export type ProductionCalendarContainerProps = {};

export const ProductionCalendarContainer: FC<
  ProductionCalendarContainerProps
> = () => {
  const { weekendsDate, submitLoading, onSubmit, onEnableEdit, onDisableEdit } =
    useProductionCalendar();

  const { t } = useTranslation();

  usePageTitle(t('directory.productionCalendar.title'));

  return (
    <DirectoryProvider
      onDisableEdit={onDisableEdit}
      onEnableEdit={onEnableEdit}
    >
      <ProductionCalendarProvider>
        <ProductionCalendarView
          submitLoading={submitLoading}
          weekendsDate={weekendsDate}
          onSubmit={onSubmit}
        />
      </ProductionCalendarProvider>
    </DirectoryProvider>
  );
};
